function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
const featuresNestedConfig = {
    nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
            name: {
                type: FIELD_TYPES.TEXT,
                label: "Feature name",
                translatable: true
            },
            text: {
                type: FIELD_TYPES.TEXT,
                label: "Feature description",
                translatable: true
            }
        }
    }
};
export default {
    type: FIELD_TYPES.NESTED,
    label: "Tier features configuration",
    fields: {
        free: _object_spread({
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: `Free tier features`
        }, featuresNestedConfig),
        basic: _object_spread({
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: `Basic tier features`
        }, featuresNestedConfig),
        standard: _object_spread({
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: `Standard tier features`
        }, featuresNestedConfig),
        pro: _object_spread({
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: `Pro tier features`
        }, featuresNestedConfig),
        enterprise: _object_spread({
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: `Enterprise tier features`
        }, featuresNestedConfig)
    }
};
